import { observer } from "mobx-react";
import { h } from "preact";
import { t, translate } from "restaumatic-client";
import NumericStepper from "../../components/NumericStepper";
import { adjustImage, makeImgUrl } from "../../utils/URL";
import CartItemDescription from "./CartItemDescription";
import CartItemPrice from "./CartItemPrice";
import AvailabilityDebugInfo from "../../components/AvailabilityDebugInfo";
import WeeklySchedulePopover from "./WeeklySchedulePopover";
import ProductLabels from "../../components/ProductLabels";
const defaultImageUrn = "/uploads/media_library/3759b3df5982ce78756f289321cb79d3.png";
function CartProductItem(props) {
    var _a;
    const { item, isImageVisible, imageType, mode = { type: "readonly" }, } = props;
    const { name, quantity, hasError } = item;
    const imageUrn = (_a = item.image) !== null && _a !== void 0 ? _a : defaultImageUrn;
    const isEditable = mode.type == "editable";
    const isScheduleErrorVisible = item.error !== null &&
        item.error.type === "ScheduleUnavailability" &&
        item.weeklySchedule !== null;
    const onItemClick = isEditable ? () => mode.edit(item.domain) : undefined;
    return (h("li", { class: `item ${hasError && "has-error"}` },
        h("div", { class: "cart-multi-column mobile" },
            isImageVisible && (h(CartItemImage, { urn: imageUrn, type: imageType, onClick: onItemClick })),
            h("div", { class: "column info" },
                h("div", null,
                    h(ProductLabels, { labelsCreator: item.labelsCreator })),
                h(CartItemDetails, { item: item, isEditable: isEditable, onClick: onItemClick }),
                h(CartItemError, { error: item.error }, isScheduleErrorVisible && (h(WeeklySchedulePopover, { id: item.id.value, weeklySchedule: item.weeklySchedule },
                    h("span", { class: "invalid-feedback u-text-underline u-text-lowercase" },
                        "(",
                        translate(t.cart.showAvailability),
                        ")")))),
                h(AvailabilityDebugInfo, { fieldId: "produictInstance.availability", name: "ProductInstance", availability: item.availability })),
            h("div", { class: "column subtotal" },
                !hasError && (h(CartItemPrice, { price: item.price, itemId: item.id.value })),
                isEditable && (h(NumericStepper, { quantity: quantity, onDecrement: () => item.decreaseQuantity(), onIncrement: () => item.increaseQuantity(), decrementFieldId: `Cart.products.${item.id.value}.decrement`, incrementFieldId: `Cart.products.${item.id.value}.increment`, quantityFieldId: `Cart.products.${item.id.value}.quantity`, decrementAriaLabel: translate(t.theme_defaults.creator.stepper.decrease, {
                        name: name,
                        from: quantity.toString(),
                        to: Math.max(quantity - 1, 0).toString(),
                        price: "",
                    }), incrementAriaLabel: translate(t.theme_defaults.creator.stepper.increase, {
                        name: name,
                        from: quantity.toString(),
                        to: (quantity + 1).toString(),
                        price: "",
                    }) }))))));
}
const CartItemImage = observer((params) => {
    const { urn, type = "square", onClick } = params;
    const isClickable = Boolean(onClick);
    const imageSrc = adjustImage({ w: 60, h: 60, crop: true }, makeImgUrl(urn !== null && urn !== void 0 ? urn : defaultImageUrn));
    const typeClass = type === "circle" ? "u-rounded-circle" : "u-border-radius";
    return (h("button", { type: "button", onClick: onClick, disabled: !isClickable, 
        // TODO: replace label while translation will be available (merged: https://github.com/restaumatic/restaumatic/pull/11057)
        // aria-label={`${translate(t.restaurants.menu.show)} ${alt}`}
        class: `cart-items__dish-picture u-btn-unstyled ${isClickable ? "" : "u-cursor-default"}`, 
        // NOTICE: Prevent focusing image, item description has its own focusable element
        tabIndex: -1 },
        h("img", { src: imageSrc, class: `cart-items__dish-image cart-items__dish-image--new-cart ${typeClass}`, alt: "" })));
});
const CartItemDetails = (props) => {
    const { item, isEditable, onClick } = props;
    const name = isEditable ? item.name : item.nameWithQuantity;
    /* TODO: check that name and choices are locale specific */
    return (h("button", { type: "button", onClick: onClick, disabled: !isEditable, class: `product-details u-btn-unstyled u-text-left ${isEditable ? "" : "u-cursor-default"}` },
        h("span", { class: "name", "data-field-id": `Cart.products.${item.id.value}.name` },
            name,
            " "),
        h("span", { class: "description", "data-field-id": `Cart.products.${item.id.value}.modifiers` }, item.description),
        !item.isSinglePart && (h("ul", { class: "m-split-pizza-list" }, item.parts.map((part) => (h("li", { class: "m-split-pizza-list__item" },
            part.name,
            ":",
            h(CartItemDescription, { text: part.description, url: null }))))))));
};
const CartItemError = observer((props) => {
    const { error, children } = props;
    if (error === null) {
        return null;
    }
    return (h("div", null,
        h("span", { class: "invalid-feedback icon-exclamation-sign icon-base u-mr1", "aria-hidden": "true" }),
        h("span", { class: "invalid-feedback" }, error.message),
        " ",
        children));
});
export default observer(CartProductItem);
